import React, { useState, useEffect } from 'react';
import { Link, Routes, Route, Router, Switch, useNavigate, useHistory } from 'react-router-dom';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const CampaignallBlue = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [showModalCmp, setShowModalCmp] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const [selectedId, setSelectedId] = useState("");
    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',  // 🔥 Keeps the entire image visible
        padding: '5px',
        borderRadius: '10px',
    };
    const containerimageStyle = {
        width: '100%',
        height: '365px',
        borderRadius: '10px',
        border: '1px dotted #e4185280',
        cursor: 'pointer',
        overflow: 'hidden'
    };
    useEffect(() => {
		axios.get(`${BASE_URL}getCampaignsBlueAll`)
		  .then(response => {
			setCampaigns(response.data);
		  })
		  .catch(error => {
			console.error("Error fetching campaigns:", error);
		  });
	  }, []);
      const openModalCmp = (img,idd) => {
        setSelectedImage(img);
        setSelectedId(idd);
        setShowModalCmp(true);
    };

    const closeModalCmp = () => {
        setShowModalCmp(false);
        setSelectedImage("");
    };
    return (
        <div>
            <body class="home-3">
                <Header />
                <section className="practise-part section-p pt-3">

                    <div className="container">
                        <hr></hr>
                        <div className="row align-items-center justify-content-center">
                            <div className="col-lg-12 text-center">
                                <h3 class="mb-3 text-primary">Blue Collar Compaign List</h3>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-center">

                        {campaigns.map((campaign, index) => (
                            <div key={`white-${index}`}  class="col-lg-3 p-2 mb-1">
                                <div style={containerimageStyle} class="campin-img"  onClick={() => openModalCmp(campaign.adwork,campaign.id)}>
                                    <img style={imageStyle} 
                                    src={`https://seagulljobs4u.com/admin/public/uploads/adwork/${campaign.adwork}`}
                                    alt={`Blue-Collar Campaign ${index + 1}`}
                                    class="img-fluid w-100" />
                                </div>
                            </div>
                         ))}   

                        </div>
                    </div>
                   
                </section>
               

                <Footer />
            </body>
            {showModalCmp && selectedImage && selectedId && (
						<>
							<div className="modal show fade d-block" tabIndex="-1" role="dialog">
								<div className="modal-dialog modal-lg" role="document">
									<div className="modal-content">
										<div className="modal-header">
											<h5 className="modal-title">Campaign Preview</h5>
											<button type="button" className="close" onClick={closeModalCmp}>
												<span>&times;</span>
											</button>
										</div>
										<div className="modal-body text-center">
											<img
												src={`https://seagulljobs4u.com/admin/public/uploads/adwork/${selectedImage}`}
												alt="Selected Campaign"
												className="campin-img"
												style={{height:"500px",width:"auto"}}
											/>
										</div>
										<div className="modal-footer">
											<button className="btn btn-secondary" onClick={closeModalCmp}>
												Close
											</button>
											{/* href={`http://localhost:3000/campaign?cid=${selectedId}`} */}
											{/* href={`https://seagulljobs4u.com/campaign?cid=${selectedId}`} */}

											<a
                  href={`https://seagulljobs4u.com/campaign?cid=${selectedId}`}
				  // href={`http://localhost:3000/campaign?cid=${selectedId}`}
                  target="_blank"
                  rel="noopener noreferrer"
				  className="btn btn-primary"
				  onClick={closeModalCmp}
                >
												Apply Now
											</a>
										</div>
									</div>
								</div>
							</div>
							<div className="modal-backdrop fade show"></div>
						</>
					)}
        </div>
    )
}

export default CampaignallBlue